import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import Checkbox from '../../checkbox-next';
import BaseNext from '../base-next';

const Wrapper = styled.div`
  position: relative;
`;

const CheckboxWrapper = styled.div`
  border-left: 1px solid ${props => props.theme.carvana.gray.light};
  display: grid;
  height: 44px;
  padding-left: 32px;
  padding-right: 32px;
  place-items: center;
  position: absolute;
  right: 0;
  top: 8px;

  &:focus {
    border: 1px solid ${props => props.theme.carvana.blue.primary};
  }
`;

const checkboxTextStyles = css`
  color: ${props => props.theme.carvana.gray.dark};
  transition: border-color 0.3s ease;

`;

const MiddleNameNext = props => {
  const { isMobile } = useSelector(state => state.ui.screenSize);
  const {
    checkbox,
    onChange,
    value,
    error,
    touched,
    onBlur,
    isDisabled,
    overrideLabel
  } = props;

  return (
    <Wrapper>
      <BaseNext
        isDisabled={isDisabled}
        data-cv-test="middleName"
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        touched={touched}
        error={error}
        id="middle"
        type="text"
        labelText={overrideLabel || 'Middle Name'}
        maxLength={30}
      />
      {typeof checkbox.onChange === 'function' && (
        <CheckboxWrapper id="noMiddleNameChecked">
          <Checkbox
            disabled={checkbox.disabled}
            text={checkbox.text || (isMobile ? 'None' : 'No middle name')}
            textStyles={checkboxTextStyles}
            onChange={checkbox.onChange}
            value={!!checkbox.value}
            tabIndex={0}
          />
        </CheckboxWrapper>
      )}
    </Wrapper>
  );
};

MiddleNameNext.propTypes = {
  checkbox: PropTypes.shape({
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    text: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func,
      PropTypes.node
    ]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
  }),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string.isRequired,
  touched: PropTypes.bool,
  isDisabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  overrideLabel: PropTypes.string
};

MiddleNameNext.defaultProps = {
  checkbox: {
    disabled: false,
    onChange: null,
    text: null,
    value: null
  },
  onChange: () => {},
  onBlur: () => {},
  touched: false,
  error: false,
  isDisabled: false,
  overrideLabel: null
};

export default MiddleNameNext;
